import { forwardRef } from 'react';
import { deletionFeedback, deletionSteps } from '../content';

// A mailto: to all three verified DoorDash addresses, prefilled with the
// campaign's short message. Built with encodeURIComponent so the subject and
// body survive as typed. This is a plain mailto, so CSP is unaffected.
const feedbackHref = `mailto:${deletionFeedback.to.join(',')}?subject=${encodeURIComponent(
  deletionFeedback.subject,
)}&body=${encodeURIComponent(deletionFeedback.body)}`;

export const Steps = forwardRef<HTMLElement>(function Steps(_props, ref) {
  return (
    <section
      className="section section--alt"
      id="how"
      ref={ref}
      aria-labelledby="how-heading"
    >
      <div className="section__inner">
        <h2 id="how-heading" className="section__title">
          How to Delete Your Account
        </h2>
        <ol className="steps">
          {deletionSteps.map((step, i) => (
            <li key={step.title} className="step">
              <span className="step__number" aria-hidden="true">
                {i + 1}
              </span>
              <div>
                <h3 className="step__title">{step.title}</h3>
                <p className="step__body">
                  {step.body.map((segment, j) =>
                    typeof segment === 'string' ? (
                      segment
                    ) : (
                      <a
                        key={j}
                        href={segment.url}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {segment.text}
                      </a>
                    ),
                  )}
                </p>
              </div>
            </li>
          ))}
        </ol>

        <div className="steps__feedback">
          <a className="btn btn--ghost" href={feedbackHref}>
            {deletionFeedback.cta}
          </a>
        </div>
      </div>
    </section>
  );
});
